import actionsTypes from '../actionTypes';
import actionTypes from '../actionTypes';

const defaultState = {
	languages: [],
	instagramAccountInfo: {
		businessid: null,
		businessName: '',
		brandName: null,
		brandProfilePic: null,
		username: null,
		id: null,
		isPrivate: null,
		isVerified: null,
		biography: null,
		followedBy: null,
		following: null,
		imagesList: [{
			id: 0,
			price: 13,
			currency: "KD",
			productName: "COAT",
			imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/s1080x1080/108152622_320376328995243_5983053028821883773_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=103&_nc_ohc=RNY_JFFrlTcAX-iLRrD&oh=845b3914ffaec5efed132900273f6f55&oe=5F3DA721"
		}, {
			id: 1,
			price: 13,
			currency: "KD",
			productName: "COAT",
			imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/s1080x1080/108152622_320376328995243_5983053028821883773_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=103&_nc_ohc=RNY_JFFrlTcAX-iLRrD&oh=845b3914ffaec5efed132900273f6f55&oe=5F3DA721"
		}, {
			id: 2,
			price: 13,
			currency: "KD",
			productName: "COAT",
			imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/s1080x1080/108152622_320376328995243_5983053028821883773_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=103&_nc_ohc=RNY_JFFrlTcAX-iLRrD&oh=845b3914ffaec5efed132900273f6f55&oe=5F3DA721"
		},
		{
			id: 3,
			price: 13,
			currency: "KD",
		}
		],
		telephoneNumber: null,
		whatsappLink: null,
		whatsappnumber: null,
		instagramLink: null,
		errorMessage: null,
		loadingInstaDetail: false,
		snap_pixel_script: null,
		productDetail: {
			imageUrl: null,
			shortcode: null,
			imageId: null,
			thumbnail: null,
			caption: null,
			isVideo: null,
			prices: []
		},
		instagram_campaign_enabled: null,
		snapchat_handle: null,
		twitter_handle: null,
		insta_handle: null,
		web_heading_key_name: "SHOP NOW", // [SHOP NOW, EXPLORE, BOOK NOW]
		end_cursor: "",
		hasNextPage: false,
		products_to_hide_list: [],
		products_to_hide_id: null,
		button_icon: "cart", // button_icon : One of [phone, cart,instagram-outline]
		button_action: "whatsapp",// One of [whatsapp, call, instagram]
		button_text: "ORDER ON WHATSAPP", // One of [BOOK NOW, ORDER ON WHATSAPP, CHECK OUR INSTAGRAM]
		button_message: "Hi there.\nThe product looks great!\nIs it available for delivery ?",
		youtube_handle: null,
		viewMore: "VIEW MORE",
		buttonInstagram: "Instagram",
		buttonWhatsapp: "WhatsApp",
		buttonPhone: "Phone",
		buttonSnapchat: "Snapchat",
		buttonTwitter: "Twitter",
		buttonMap: "Map",
		buttonYoutube: "Youtube",
		showIconButtonNames: false,


	},
	no_of_products_to_show: null,
	featuredProductsList: [{
		imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/106793886_2203616089784236_8264455556258650893_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=F0Q2lM9FJZMAX8c1nQA&oh=fc8d881cdc866b2d6e9a8f3d35c3d177&oe=5F409CB5",
		shortcode: "CCeKL1whIjO",
		imageId: "2350360849635641550",
		productDescription: "We love seeing our dresses on our customers 😍 share with us your looks x",
		isVideo: false,
		price: 13,
		currency: "KD",
		productName: "COAT",
	}, {
		imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/106793886_2203616089784236_8264455556258650893_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=F0Q2lM9FJZMAX8c1nQA&oh=fc8d881cdc866b2d6e9a8f3d35c3d177&oe=5F409CB5",
		shortcode: "CCeKL1whIjO",
		imageId: "2350360849635641550",
		productDescription: "We love seeing our dresses on our customers 😍 share with us your looks x",
		isVideo: false,
		price: 13,
		currency: "KD",
		productName: "COAT",
	}, {
		imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/106793886_2203616089784236_8264455556258650893_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=F0Q2lM9FJZMAX8c1nQA&oh=fc8d881cdc866b2d6e9a8f3d35c3d177&oe=5F409CB5",
		shortcode: "CCeKL1whIjO",
		imageId: "2350360849635641550",
		productDescription: "We love seeing our dresses on our customers 😍 share with us your looks x",
		isVideo: false,
		price: 13,
		currency: "KD",
		productName: "COAT",
	}],
	popularProductsList: [{
		imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/106793886_2203616089784236_8264455556258650893_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=F0Q2lM9FJZMAX8c1nQA&oh=fc8d881cdc866b2d6e9a8f3d35c3d177&oe=5F409CB5",
		shortcode: "CCeKL1whIjO",
		imageId: "2350360849635641550",
		productDescription: "We love seeing our dresses on our customers 😍 share with us your looks x",
		isVideo: false,
		price: 13,
		currency: "KD",
		productName: "COAT",
	}, {
		imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/106793886_2203616089784236_8264455556258650893_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=F0Q2lM9FJZMAX8c1nQA&oh=fc8d881cdc866b2d6e9a8f3d35c3d177&oe=5F409CB5",
		shortcode: "CCeKL1whIjO",
		imageId: "2350360849635641550",
		productDescription: "We love seeing our dresses on our customers 😍 share with us your looks x",
		isVideo: false,
		price: 13,
		currency: "KD",
		productName: "COAT",
	}, {
		imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/106793886_2203616089784236_8264455556258650893_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=F0Q2lM9FJZMAX8c1nQA&oh=fc8d881cdc866b2d6e9a8f3d35c3d177&oe=5F409CB5",
		shortcode: "CCeKL1whIjO",
		imageId: "2350360849635641550",
		productDescription: "We love seeing our dresses on our customers 😍 share with us your looks x",
		isVideo: false,
		price: 13,
		currency: "KD",
		productName: "COAT",
	},
	{
		imageUrl: "https://instagram.fkwi8-1.fna.fbcdn.net/v/t51.2885-15/e35/p1080x1080/106793886_2203616089784236_8264455556258650893_n.jpg?_nc_ht=instagram.fkwi8-1.fna.fbcdn.net&_nc_cat=104&_nc_ohc=F0Q2lM9FJZMAX8c1nQA&oh=fc8d881cdc866b2d6e9a8f3d35c3d177&oe=5F409CB5",
		shortcode: "CCeKL1whIjO",
		imageId: "2350360849635641550",
		productDescription: "We love seeing our dresses on our customers 😍 share with us your looks x",
		isVideo: false,
		price: 13,
		currency: "KD",
		productName: "COAT",
	}
	],
	explore_products: [],
	categories: [
		{
			"id": "86",
			"name": "CATEGORY 1",
			"media": [
				{
					"id": "140",
					"imageId": "2372610843559706025",
					"shortcode": "CDtNP3Ynb2p",
					"url": "https://s3.ap-south-1.amazonaws.com/optimizeapp-ecommerce/media/1597586603.jpg"
				},

			]
		},
		{
			"id": "92",
			"name": "CATEGORY 2",
			"media": [
				{
					"id": "137",
					"imageId": "2373310957655719864",
					"shortcode": "CDvsb3cnH-4",
					"url": "https://s3.ap-south-1.amazonaws.com/optimizeapp-ecommerce/media/1597588461.jpg"
				}
			]
		},
		{
			"id": "90",
			"name": "CATEGORY 3",
			"media": [
				{
					"id": "145",
					"imageId": "2363879751939891729",
					"shortcode": "CDOMBwqHaIR",
					"url": "https://s3.ap-south-1.amazonaws.com/optimizeapp-ecommerce/media/1597588627.jpg"
				}
			]
		},
		{
			"id": "97",
			"name": "CATEGORY 4",
			"media": [
				{
					"id": "144",
					"imageId": null,
					"shortcode": null,
					"url": "https://s3.ap-south-1.amazonaws.com/optimizeapp-ecommerce/media/1P92U0PYCi9vXA5ZwIua2mXPb5DrDkdQRm5Ppwq9.jpeg"
				}
			]
		}
	]
};

/**
 *
 *
 * @param {*} [state=defaultState]
 * @param {*} action
 * @returns
 */
const campaignReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionsTypes.SET_LANGUAGE_LIST: {
			return {
				...state,
				languages: action.payload,
			};
		}

		case actionsTypes.SET_INSTA_ACCOUNT_DETAILS: {

			return {
				...state,
				no_of_products_to_show: action.payload.no_of_products_to_show,
				instagramAccountInfo:
					action.payload,
				featuredProductsList: action.payload.featured_products,
				popularProductsList: action.payload.popular_products,
				explore_products: action.payload.explore_products,
				loadingInstaDetail: false,
				errorMessage: null,
			};
		}
		case actionsTypes.ERROR_INSTA_ACCOUNT_DETAILS: {
			return {
				...state,
				instagramAccountInfo: defaultState.instagramAccountInfo,
				loadingInstaDetail: false,
				errorMessage: action.payload.message,
			};
		}
		case actionTypes.UPDATE_ACCOUNT_INFO: {
			return {
				...state,
				instagramAccountInfo: {
					...state.instagramAccountInfo,
					brandProfilePic: action.payload.brandProfilePic
				}
			}
		}
		case actionTypes.SET_LOADING: {
			return {
				...state,
				loadingInstaDetail: action.payload,
			};
		}
		case actionTypes.GET_MORE_INSTAGRAM_POST: {
			var imagesList = [...state.instagramAccountInfo.imagesList, ...action.payload.imagesList]

			// // check and remove all the hidden products
			// if (state.instagramAccountInfo.products_to_hide_id
			// 	&& state.instagramAccountInfo.products_to_hide_list
			// 	&& state.instagramAccountInfo.products_to_hide_list.length > 0) {
			// 	imagesList = imagesList.filter((image) => {
			// 		return !state.instagramAccountInfo.products_to_hide_list.includes(image.imageId)
			// 	})
			// }
			return {
				...state,
				instagramAccountInfo: {
					...state.instagramAccountInfo,
					...action.payload,
					imagesList: [...imagesList],

				}
			}
		}
		case actionTypes.ERROR_GET_MORE_INSTAGRAM_POST: {
			return {
				...state,
				instagramAccountInfo: {
					...state.instagramAccountInfo,
					imagesList: [...state.instagramAccountInfo.imagesList, ...action.payload.imagesList],
					...action.payload,

				}
			}
		}
		case actionTypes.SET_PRODUCT_DETAIL: {
			return {
				...state,
				instagramAccountInfo: {
					...state.instagramAccountInfo,
					productDetail: action.payload
				}
			}
		}
		case actionTypes.SET_FILTER_PRODUCTS: {
			return {
				...state,
				popularProductsList: action.payload.popularProductsList,
				featuredProductsList: action.payload.featuredProductsList,
				explore_products: action.payload.explore_products
			}
		}
		default:
			return state;
	}
};

export default campaignReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/campaign.reducer.js